import { useState, useRef } from "react";
import "./checkbox.css";

export const Checkbox = ({onClick}) => {
    const [isChecked, setIsChecked] = useState(false);
    const checkedRef = useRef(false)
    
    const onHandleClick = () => {
        checkedRef.current = !checkedRef.current
        onClick(checkedRef.current);
    }

  return (
    <div className="checkbox" onClick={onHandleClick}>
      <input
        className={isChecked ? "checked" : ""}
        type="checkbox"
        checked={isChecked}
        onChange={() => setIsChecked((prev) => !prev)}
      />
    </div>
  );
};
